import React from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useCssStyle } from '../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import CustomPressable from '../../components/customPressable/customPressable';
import HeaderWithBack from '../../components/Header/headerWithBack';
import moment from 'moment';
import { toBool } from '../../utils/Helper';
import { useSelector } from 'react-redux';
import { formatTime } from '../../js/formatTime';

const ActivitiesConfirmBooking = (props) => {
    const { selectedEvent, handleNext, handleGoBack } = props;

    const { extraConfigParam } = useSelector(state => state.deviceConfigSlice)

    const dateFormat = extraConfigParam?.DATE_FORMAT;
    const TIME_FORMAT = extraConfigParam?.TIME_FORMAT_MERIDIEM || false;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const applicableTaxes = (selectedEvent?.eventInfo?.taxes || []).filter(
        t => !t.includedInPrice && t.percentage
    );

    const addonsApplicableTaxes = (selectedEvent?.eventInfo?.addOns?.taxes || []).filter(
        t => !t.includedInPrice && t.percentage
    )

    const priceTierBaseAmount =
        selectedEvent?.priceTiers?.reduce(
            (acc, curr) => acc + (curr.quantity * curr.price),
            0
        ) || 0;

    const addOnBaseAmount =
        selectedEvent?.addOns?.reduce(
            (acc, curr) => acc + (curr.quantity * curr.price),
            0
        ) || 0;

    const calculateTaxes = (baseAmount) => {
        return applicableTaxes.map(tax => ({
            ...tax,
            amount: (baseAmount * tax.percentage) / 100
        }));
    };

    const calculateAddonsTaxes = (baseAmount) => {
        return addonsApplicableTaxes.map(tax => ({
            ...tax,
            amount: (baseAmount * tax.percentage) / 100
        }));
    }

    const getFinanceInfo = () => {
        const totalTax = priceTierBaseAmount + addOnBaseAmount;
        const totalCost = totalTax + [...priceTierTaxes, ...addOnTaxes].reduce((a, b) => a + b.amount, 0);

        return { totalTax, totalCost }
    }

    const priceTierTaxes = calculateTaxes(priceTierBaseAmount);
    const addOnTaxes = calculateAddonsTaxes(addOnBaseAmount);

    return (
        <View style={getStyles(['widgetRootContainer', 'activitiesConfirmBookingRootContainer'])} id='activitiesConfirmBookingRootContainer'>
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true}
                contentContainerStyle={getStyles(['widgetmainContainer', 'activitiesConfirmBookingMainContainer'])}
                showsVerticalScrollIndicator={false}
                id='activitiesConfirmBookingMainContainer'
            >
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'activitiesAdditionlaDetailsHeaderTitleContainer'])} id='activitiesAdditionlaDetailsHeaderTitleContainer'>
                    <Text style={getStyles(['activitiesAdditionlaDetailsHeaderTitle'])} id='activitiesAdditionlaDetailsHeaderTitle'>
                        {t("way_activity.confirm_booking.confirm_heading")}
                    </Text>

                    <Text style={getStyles(['activitiesAdditionlaDetailsHeaderSubTitle'])} id='activitiesAdditionlaDetailsHeaderSubTitle'>
                        {t("way_activity.confirm_booking.confirm_subheading")}
                    </Text>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'activitiesCreateBookingMainContainerChildContainer'])} id='activitiesCreateBookingMainContainerChildContainer'>

                    <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.event_title")}</Text>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{selectedEvent.event.title}</Text>
                    </View>

                    {selectedEvent.subEvent && (
                        <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.subevent_title")}</Text>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{selectedEvent.subEvent.title}</Text>
                        </View>
                    )}

                    <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.date")}</Text>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>
                            {moment(selectedEvent.date).format(dateFormat.toUpperCase())}
                        </Text>
                    </View>

                    <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.time_slot")}</Text>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>
                            {`${formatTime(selectedEvent.timeSlot.startTime, toBool(TIME_FORMAT))} - ${formatTime(selectedEvent.timeSlot.endTime, toBool(TIME_FORMAT))}`}
                        </Text>
                    </View>

                    {selectedEvent?.priceTiers?.some(p => p.quantity > 0) && (
                        <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.package")}</Text>
                            {selectedEvent.priceTiers.map(p => {
                                if (p.quantity === 0) return null;
                                return (
                                    <View key={p.name} style={getStyles(['activitiesAdditionlaDetailsTitleTextContainer'])}>
                                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${p.name} (x${p.quantity})`}</Text>
                                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${selectedEvent?.eventInfo?.currency} ${p.price}`}</Text>
                                    </View>
                                )
                            })}
                        </View>
                    )}

                    {priceTierTaxes.length > 0 && (
                        <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.taxes")}</Text>
                            {priceTierTaxes.map(tax => (
                                <View key={tax.id} style={getStyles(['activitiesAdditionlaDetailsTitleTextContainer'])}>
                                    <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${tax.name} (${tax.percentage}%)`}</Text>
                                    <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>
                                        {`${selectedEvent?.eventInfo?.currency} ${tax.amount.toFixed(2)}`}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    )}

                    {selectedEvent?.addOns?.some(a => a.quantity > 0) && (
                        <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.add_on")}</Text>
                            {selectedEvent.addOns.map(a => {
                                if (a.quantity === 0) return null;
                                return (
                                    <View key={a.label} style={getStyles(['activitiesAdditionlaDetailsTitleTextContainer'])}>
                                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${a.label} (x${a.quantity})`}</Text>
                                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${selectedEvent?.eventInfo?.currency} ${a.price}`}</Text>
                                    </View>
                                )
                            })}
                        </View>
                    )}

                    {addOnTaxes.length > 0 && (
                        <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                            <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.addon_taxes")}</Text>
                            {addOnTaxes.map(tax => (
                                <View key={tax.id} style={getStyles(['activitiesAdditionlaDetailsTitleTextContainer'])}>
                                    <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>{`${tax.name} (${tax.percentage}%)`}</Text>
                                    <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>
                                        {`${selectedEvent?.eventInfo?.currency} ${tax.amount.toFixed(2)}`}
                                    </Text>
                                </View>
                            ))}
                        </View>
                    )}

                    <View style={getStyles(['activitiesAdditionlaDetailsTextCotainer'])}>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitle'])}>{t("way_activity.confirm_booking.total")}</Text>
                        <Text style={getStyles(['activitiesAdditionlaDetailsTitleText'])}>
                            {`${selectedEvent?.eventInfo?.currency} ${
                                priceTierBaseAmount +
                                addOnBaseAmount +
                                [...priceTierTaxes, ...addOnTaxes].reduce((a, b) => a + b.amount, 0)
                            }`}
                        </Text>
                    </View>

                </View>
            </ScrollView>

            <View id='activitiesBookingNextButtonContainer' style={getStyles(['activitiesBookingNextButtonContainer'])}>
                <CustomPressable style={getStyles(['primaryBtn'])} onPress={() => handleNext(selectedEvent.event, getFinanceInfo())} id="primaryBtn">
                    <Text style={getStyles(['primaryBtnTxt'])}>
                        {t('way_activity.confirm_booking.confirm_button')}
                    </Text>
                </CustomPressable>
            </View>
        </View>
    )
}

export default ActivitiesConfirmBooking
